import Image from 'next/image';
import { scrollToElement } from '../../shared/useCommon';
import { KeyFactsStyle } from '../../styles/components/country';

export interface IKeyFactsProps {
  title?: string;
  facts: {
    title: string;
    text: string;
    tip?: string;
    iconUrl: string;
    anchor?: string;
  }[];
}

const KeyFacts = (props: IKeyFactsProps) => {
  const goToAnchor = (anchor?: string) => {
    if (!!anchor) {
      scrollToElement(anchor);
    }
  };

  return (
    <div className={KeyFactsStyle['key-facts']}>
      <h2>{props.title}</h2>
      <div className={KeyFactsStyle['key-facts-items']}>
        {props.facts.map((fact, index) => (
          <div
            key={index}
            className={`${KeyFactsStyle['key-fact-item']} ${
              !!fact.anchor ? KeyFactsStyle['key-fact-item-clickable'] : ''
            }`}
            onClick={() => goToAnchor(fact.anchor)}>
            <div className={KeyFactsStyle['key-fact-item-icon']}>
              <Image
                src={fact.iconUrl}
                alt={fact.title}
                width={30}
                height={30}
              />
            </div>
            <p className={KeyFactsStyle['key-fact-item-title']}>{fact.title}</p>
            <p className={KeyFactsStyle['key-fact-item-text']}>{fact.text}</p>
            {fact.tip && (
              <span className={KeyFactsStyle['key-fact-item-tip']}>
                {fact.tip}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default KeyFacts;
